export const textInfo = [
    {
        text:"code is not tough you learn from code if you are hard worker,like to do experiments",
        by:"Sir Syed Murtza"
    },
    {
        text:"if we focuse on one path then we learn a lot,i understand this logics in may,2019,from the help of my teacher",
        by:"Kashif Naqvi"
    },
    {
        text:"if you make any thing start from the basic,if understand then no problem to you for makeing any complex Application",
        by:"Sadaif Rizvi"
    },
    {
        text:"you spend  a time to learn only one skills at a time,if you expert in it then choose next",
        by:"Hizqeel Sabzwari"
    }
]